import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Loader2 } from "lucide-react";

const TransitionModal = ({ isOpen, onClose, onContinue }) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-sm px-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 180, damping: 20 }}
            className="relative w-full max-w-md bg-white text-black rounded-2xl border border-neutral-200 
                       shadow-[0_8px_40px_rgba(0,0,0,0.15)] p-8 text-center"
          >
            {/* Loader Animation */}
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ repeat: Infinity, duration: 2, ease: 'linear' }}
              className="flex justify-center mb-4"
            >
              <Loader2 size={28} className="text-black" />
            </motion.div>

            <h2 className="text-lg font-semibold mb-2">Submission Received</h2>
            {/* <p className="text-sm text-neutral-600 leading-relaxed mb-6">
              Your submission has been recorded — but nothing’s saved yet.
              Codi is preparing your feedback workspace to help you reflect
              on what went well and where you struggled.
            </p> */}

            <button
              onClick={onContinue}
              className="px-5 py-2 rounded-xl bg-black text-white text-sm font-medium 
                         hover:bg-neutral-800 transition"
            >
              Continue to Feedback
            </button>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default TransitionModal;
